import { CodeListWire } from 'app/area/codetable/common';
import { mapListToStore } from 'app/area/codetable/list/mapping/map-list-to-store';
import { RiskMatrixSortOrderType } from 'app/area/risk-matrix-administration/constants';
import { RiskMatrixAxes } from 'app/area/risk-matrix-administration/types-store';

export const mapToAxes = (axes: CodeListWire[] = [], axesIds: number[] = [], axesSortOrderTypes: number[] = []): RiskMatrixAxes =>
  axes
    .map((axis, index) => ({
      codetableId: axesIds[index],
      items: mapListToStore(axesSortOrderTypes[index] === RiskMatrixSortOrderType.descending
        ? [...(axis?.results ?? []).reverse()]
        : axis?.results),
      sortOrderType: axesSortOrderTypes[index]
    }));
